import React from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { consentChartOptions } from "./chartOptions";
import EmptyChart from "./EmptyChart";

// Custom plugin to add margin between legend and chart
export const customMarginPlugin = {
  id: "customMarginPlugin",
  beforeInit: function (chart) {
    const originalFit = chart.legend.fit;
    chart.legend.fit = function fit() {
      originalFit.bind(chart.legend)();
      this.height += chartsLegendMargin; // Adds the extra margin
    };
  },
};
export const chartsLegendMargin = 25;

const LineChart = (props) => {
  const { data, width, height, dataName, noFiltersApplied } = props;

  // Aggregate data by timestamp (summing across consent types and containers)
  const aggregateByTimestamp = () => {
    // Group by timestamp and sum values
    const aggregated = {};
    data?.forEach((item) => {
      if (!aggregated[item.timestamp]) {
        aggregated[item.timestamp] = {
          timestamp: item.timestamp,
          granted: 0,
          denied: 0,
          total_values: 0,
        };
      }
      aggregated[item.timestamp].granted += item.granted;
      aggregated[item.timestamp].denied += item.denied;
      aggregated[item.timestamp].total_values += item.total_values;
    });

    // Convert to array and sort by timestamp
    return Object.values(aggregated).sort((a, b) =>
      a.timestamp.localeCompare(b.timestamp),
    );
  };

  const buildChartData = () => {
    const aggregatedData = aggregateByTimestamp();
    return {
      labels: aggregatedData?.map((item) => item.timestamp),
      datasets: [
        {
          label: "Granted",
          data: aggregatedData?.map((item) =>
            item.total_values > 0
              ? (item.granted / item.total_values) * 100
              : 0,
          ),
          fill: false,
          backgroundColor: "rgb(43, 43, 181)",
          borderColor: "rgb(43, 43, 181)",
          borderWidth: 3, // Adjust line thickness
          tension: 0.4, // Adjust curve tension (0.4 for moderate curve)
          pointRadius: 0, // Remove data points
          pointBorderColor: "#fff",
          pointHoverBackgroundColor: "#fff",
        },
        {
          label: "Denied",
          data: aggregatedData?.map((item) =>
            item.total_values > 0 ? (item.denied / item.total_values) * 100 : 0,
          ),
          fill: false,
          backgroundColor: "rgb(219, 241, 255)",
          borderColor: "rgb(219, 241, 255)",
          borderWidth: 3, // Adjust line thickness
          tension: 0.4, // Adjust curve tension (0.4 for moderate curve)
          pointRadius: 0, // Remove data points
          pointBorderColor: "#fff",
          pointHoverBackgroundColor: "#fff",
        },
      ],
    };
  };

  const chartData = buildChartData();

  return (
    <EmptyChart
      chartData={chartData}
      dataName={dataName}
      noFiltersApplied={noFiltersApplied}
    >
      <Line
        data={chartData}
        plugins={[customMarginPlugin]}
        options={consentChartOptions(2000)}
        width={width}
        height={height}
      />
    </EmptyChart>
  );
};

export default LineChart;
